import * as React from 'react';
import { Form, Select, Input, Cascader, Card, Empty, Button } from 'antd';
import { Container } from '@mui/material';

import 'antd/dist/antd.css';

import DragSortingUpload from '../../../components/DragSortingUpload';
import { SingleProductContext } from '../context/SingleProductContext';
import NewIngredientModal from './newIngredientModal';
import { toSlug } from '../../../utils';

export default function ProductDetailCard({ form }) {
  const { categoriesOption, ingredientTags, brandsOption, productDetail, addNewIngredient } =
    React.useContext(SingleProductContext);

  const { Option } = Select;
  const { TextArea } = Input;

  const [searchIngredient, setSearchIngredient] = React.useState('');

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }

    return e && e.fileList;
  };

  const handleNameChange = (event) => {
    // console.log(event.target.value);
    let slugText = toSlug(event.target.value);
    form.setFieldsValue({
      slug: slugText,
    });
  };

  React.useEffect(() => {
    if (
      productDetail && // 👈 null and undefined check
      Object.keys(productDetail).length === 0 &&
      Object.getPrototypeOf(productDetail) === Object.prototype
    ) {
      form.resetFields();
    } else {
      form.setFieldsValue(productDetail);
    }
  }, [productDetail]);

  return (
    <Card>
      <Container sx={{ py: 3 }}>
        <h2>รายละเอียดสินค้า</h2>

        <Form.Item
          label='Cover Pic'
          name='coverPic'
          valuePropName='fileList'
          getValueFromEvent={normFile}
          required
          help='รูปควรเป็น สี่เหลี่ยมจัตุรัส และขนาดไม่เกิน 2 MB'
          rules={[{ required: true, message: 'กรุณาระบุรูปสินค้า' }]}>
          <DragSortingUpload maxCount={1} />
        </Form.Item>

        <Form.Item label='Gallery (max: 8)'>
          <Form.Item
            name='gallery'
            valuePropName='fileList'
            getValueFromEvent={normFile}
            // required
            help='รูปควรเป็น สี่เหลี่ยมจัตุรัส และขนาดไม่เกิน 2 MB'
            // rules={[{ required: true, message: 'กรุณาระบุรูปสินค้า' }]}>
          >
            <DragSortingUpload maxCount={8} />
          </Form.Item>
        </Form.Item>

        <Form.Item name='brand' label='แบรนด์' required rules={[{ required: true, message: 'กรุณาระบุแบรนด์สินค้า' }]}>
          <Select
            showSearch
            style={{ width: '100%' }}
            optionFilterProp='children'
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            listHeight={128}
            placeholder='เลือก Brand'>
            {brandsOption.map((brand) => (
              <Option key={brand.id} value={brand.id} label={brand.name}>
                {brand.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name='product_name'
          label='ชื่อสินค้า'
          required
          rules={[{ required: true, message: 'กรุณาระบุชื่อสินค้า' }]}>
          <Input showCount placeholder='ชื่อสินค้า' onChange={handleNameChange} />
        </Form.Item>

        <Form.Item name='slug' label='Slug' required rules={[{ required: true, message: 'กรุณาระบุ Slug URL' }]}>
          <Input placeholder='Slug URL' />
        </Form.Item>

        <Form.Item
          name='link_to_product'
          label='Action Link'
          // required
          // rules={[{ required: true, message: 'กรุณาระบุ link ของ line OA' }]}>
        >
          <Input showCount placeholder='A link to LINE OA' />
        </Form.Item>

        <Form.Item
          name='description'
          label='รายละเอียดสินค้า'
          required
          rules={[{ required: true, message: 'กรุณาระบุรายละเอียดสินค้า' }]}>
          <TextArea showCount placeholder='รายละเอียด' style={{ height: 150 }} />
        </Form.Item>

        <Form.Item
          name='category'
          label='เลือกหมวดหมู่'
          required
          rules={[{ required: true, message: 'กรุณาระบุหมวดหมู่' }]}>
          <Cascader
            options={categoriesOption}
            placeholder='Please select category'
            fieldNames={{ label: 'name', value: 'id' }}
          />
        </Form.Item>

        <Form.Item name='ingredients' label='Ingredients'>
          <Select
            mode='multiple'
            style={{ width: '100%' }}
            listHeight={128}
            placeholder='เลือก Ingredient'
            onSearch={(e) => setSearchIngredient(e)}
            // defaultValue={[1]}
            // optionLabelProp='label'
            notFoundContent={
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                // imageStyle={{
                //   height: 60,
                // }}
                description={<span>ไม่พบ Ingredient ชนิดนี้</span>}>
                <Button type='primary' onClick={() => addNewIngredient(searchIngredient)}>
                  เพิ่ม Ingredient นี้ทันที
                </Button>
              </Empty>
            }
            optionFilterProp='label'>
            {ingredientTags.map((tag) => (
              <Option key={tag.id} value={tag.id} label={tag.value}>
                {tag.value}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Container>
      <NewIngredientModal />
    </Card>
  );
}
